import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Sidebar expansion bus of the product layout. The light/dark theme it used to hold
 * lives in lib-trend-core's ColorThemeService, shared with the chat app (DEV-2062).
 */
@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private expandedSidebar$ = new BehaviorSubject<boolean>(false);

  toggleExpandSidebar(isExpanded: boolean){
    this.expandedSidebar$.next(isExpanded);
  }

  getExpandedSidebar() {
    return this.expandedSidebar$.asObservable();
  }
}
